module.exports = __webpack_public_path__ + "static/media/preview_image_DELETE3.e299d1b5.png";